import Flydot from "./src/main.js"
export default Flydot
